import { render, staticRenderFns } from "./BuyingStationRoles.vue?vue&type=template&id=5b62c7a8&scoped=true"
import script from "./BuyingStationRoles.vue?vue&type=script&lang=js"
export * from "./BuyingStationRoles.vue?vue&type=script&lang=js"
import style0 from "./BuyingStationRoles.vue?vue&type=style&index=0&id=5b62c7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b62c7a8",
  null
  
)

export default component.exports